import {useQuery} from '@tanstack/react-query'
import React, {useEffect} from 'react'
import {QueryCacheKeys} from '../../QueryKey'
import {getCommentDetail} from '../../../apis/comment/getCommentDetail'

const useQueryCommentDetail = (id?: string) => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.comment.getCommentDetail(id),
        queryFn: async () => {
            const {data} = await getCommentDetail(id)
            return data
        },
        refetchOnWindowFocus: false,
    })

    useEffect(() => {
        refetch()
    }, [])

    return {data, refresh: refetch, isLoading}
}

export default useQueryCommentDetail
